import select2Factory from 'select2';
import 'select2/dist/css/select2.css';

const $ = window.jQuery;

if ($) {
  if (!$.fn.select2) {
    select2Factory(window, $);
  }

  window.rebredgVendors = window.rebredgVendors || {};
  window.rebredgVendors.select2Jquery = $;
}
